import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import NotFound from "../../components/NotFound/NotFound";
import BookingIdCard from "../../components/BookingIdCard/BookingIdCard";
import ProviderDetails from "../../components/ProviderDetails/ProviderDetails";
import PriceSplitUp from "../../components/BookingDetail/PriceDetails/PriceSplitUp/PriceSplitUp";
import CommonModal from "../../components/Modal/CommonModal";
import AdditionalRequestForm from "../../components/AdditionalRequestForm/AdditionalRequestForm";
import ChatMessages from "../../components/ChatMessages/ChatMessages";
import ChatMessageSkeleton from "../../components/Skeleton/ViewBooking/ChatMessageSkeleton/ChatMessageSkeleton";

import history from "../../history";
import messages from "../../locale/messages";
import { closeHeaderModal, openHeaderModal } from "../../actions/siteadmin/modalActions";

import useQueryResponse from "../../lib/hooks/useQueryResponse";
import SocketContext from "../../core/socketNotifications/SocketContext";

import getBookingById from './getBookingById.graphql';

import { AngleLeftArrowIcon } from "../../components/Common/Assets/SVGIcon/CommonSvgIcon";
import bt from '../../components/commonStyle.css';

const InboxContainer = ({ id }) => {

    const [load, setLoad] = useState(false)
    const [isCompletedSocketEmitted, setIsCompletedSocketEmitted] = useState(false);
    const dispatch = useDispatch()
    const intl = useIntl()

    const handleCompleteSocketEmitter = (value) => setIsCompletedSocketEmitted(value);

    useEffect(() => {
        setLoad(true)
        return () => {
            handleCompleteSocketEmitter(false);
        }
    }, [])

    const { data, loading } = useQueryResponse({
        query: getBookingById,
        variables: {
            bookingId: id
        },
        fetchPolicy: 'network-only',
        ssr: false
    })

    let categoryName, serviceFee, total, subTotal, visitFee, discount, isBookingCompleted, currency, tipsAmount;
    const redirectTo = history?.location?.state?.from ? history?.location?.state?.from : `/tracking/${id}`;
    isBookingCompleted = data?.getBookingById?.result?.status === 'completed' ? true : false;

    categoryName = data?.getBookingById?.result?.categoryDetails?.name;
    serviceFee = data?.getBookingById?.result?.userServiceFee;
    visitFee = data?.getBookingById?.result?.travellingPrice;
    total = data?.getBookingById?.result?.userPayableFare;
    subTotal = data?.getBookingById?.result?.subTotal;
    discount = data?.getBookingById?.result?.specialServiceFare;
    currency = data?.getBookingById?.result?.currency;
    tipsAmount = data?.getBookingById?.result?.tipsAmount

    const additionalRequest = useSelector(state => state.adminModalStatus.additionalRequest)

    const closeAdditionalModal = () => {
        if (data?.getBookingById?.result?.additionalFeeStatus === 'approved') {
            dispatch(closeHeaderModal('additionalRequest'));
        }
    }

    let formData = {
        noCloseIcon: true
    }

    !isBookingCompleted && (data?.getBookingById?.result?.additionalFeeStatus === 'pending' && dispatch(openHeaderModal('additionalRequest', formData)))

    if (!loading && data?.getBookingById?.result == null) {
        return <NotFound title={'Page Not Found'} />
    } else if (!isCompletedSocketEmitted && isBookingCompleted) {
        // A completed booking has no live chat. Instead of showing a 404, send the client to the
        // booking detail (the invoice) — that's the natural place for a finished job.
        if (typeof window !== 'undefined') history.replace('/booking/' + id);
        return <div className={'subPageContainer'}><ChatMessageSkeleton /></div>
    } else if (!load || loading) {
        return <div className={'subPageContainer'}><ChatMessageSkeleton /></div>
    } else {
        return (
            <>
                <CommonModal
                    title={intl.formatMessage(messages.additionalWorkRequest)}
                    modalStatus={additionalRequest}
                    onHide={closeAdditionalModal}
                >
                    <AdditionalRequestForm id={id} fee={data?.getBookingById?.result?.requestedAdditionalFee}
                        details={data?.getBookingById?.result?.requestedAdditionalFeeDescription}
                        currency={data?.getBookingById?.result?.currency} bookingDetails={getBookingById?.result}
                        secondDifference={data?.getBookingById?.result?.secondDifference}
                        additionalWorkInterval={data?.getBookingById?.result?.additionalWorkInterval}
                        data={data?.getBookingById?.result} />
                </CommonModal>
                <div className={'subPageContainer'}>
                    <Container>
                        <div className={bt.space3}>
                            <a href={redirectTo} onClick={(e) => {
                                e.preventDefault();
                                if (typeof window !== 'undefined') {
                                    if (window.history.length > 1) {
                                        window.history.back();
                                    } else {
                                        history.push(`/tracking/${id}`);
                                    }
                                }
                            }} className={cx(bt.customLink, 'customLinkRtl')}>
                                <AngleLeftArrowIcon />
                                <FormattedMessage {...messages.goBackText} />
                            </a>
                        </div>
                        <div className={bt.commonViewBookingContainer}>
                            <div className={cx(bt.commonViewBookingLsBox, bt.commonLsMinHeight)}>
                                <SocketContext.Consumer>
                                    {socket => <ChatMessages bookingId={id} socket={socket} handleCompleteSocketEmitter={handleCompleteSocketEmitter} />}
                                </SocketContext.Consumer>
                            </div>
                            <div className={bt.commonStickyRsContainer}>
                                <BookingIdCard id={id} isTrackPage={true} status={data?.getBookingById?.result?.status} isTopRadius={true} />
                                <ProviderDetails id={id} isMessage={true} data={data?.getBookingById?.result} isNotMapPage={true} />
                                <PriceSplitUp
                                    data={data?.getBookingById}
                                    categoryName={categoryName}
                                    serviceFee={serviceFee}
                                    visitFee={visitFee}
                                    total={total}
                                    discount={discount}
                                    currency={currency}
                                    fee={data?.getBookingById?.result?.additionalFee}
                                    description={data?.getBookingById?.result?.requestedAdditionalFeeDescription}
                                    tipsAmount={tipsAmount}
                                />
                            </div>
                        </div>
                    </Container>
                </div>
            </>
        )
    }
}

export default withStyles(bt)(InboxContainer);
